import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { FreeComponentsBadge } from "./FreeComponentsBadge";
import AddIcon from "@mui/icons-material/Add";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import type { Operator } from "../../../../types/operator";

const checkboxSx = {
  color: "#888",
  "&.Mui-checked": { color: "hsl(19 101% 51% / 1)" },
};

type ManageAirframeFilterProps = {
  freeComponent: any[];
  onCreateClick: () => void;
  operators: Operator[];
  operatorFilters: Set<string>;
  onOperatorFilterToggle: (id: string) => void;
  showOperatorFilter: boolean;
};

const ManageAirframeFilter: React.FC<ManageAirframeFilterProps> = ({
  freeComponent,
  onCreateClick,
  operators,
  operatorFilters,
  onOperatorFilterToggle,
  showOperatorFilter,
}: ManageAirframeFilterProps) => {
  const canCreateAirframe = useHasPermission("assets-airframes", "create");

  return (
    <Paper
      sx={{
        bgcolor: "#111",
        color: "#fff",
        border: "1px solid #333",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Scrollable content area */}
      <Box sx={{ overflowY: "auto", flexGrow: 1, p: 2 }}>
        <Typography variant="h6" sx={{ color: "hsl(19 101% 51% / 1)", mb: 2 }}>
          Airframe Actions
        </Typography>

        {canCreateAirframe && (
          <Button
            startIcon={<AddIcon />}
            fullWidth
            sx={{
              mt: 2,
              bgcolor: "hsl(19 101% 51% / 1)",
              color: "#fff",
              "&:hover": {
                bgcolor: "hsl(19 101% 41% / 1)",
              },
            }}
            variant="contained"
            onClick={onCreateClick}
          >
            Add Airframe
          </Button>
        )}

        <FreeComponentsBadge count={freeComponent.length} />

        {showOperatorFilter && operators.length > 0 && (
          <>
            <Divider sx={{ my: 2, bgcolor: "#333" }} />
            <Typography
              variant="subtitle2"
              sx={{
                color: "#aaa",
                mb: 1,
                fontSize: "0.75rem",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              Operator
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
              {operators.map((op, index) => (
                <FormControlLabel
                  key={op.id}
                  control={
                    <Checkbox
                      size="small"
                      checked={operatorFilters.has(op.id)}
                      onChange={() => onOperatorFilterToggle(op.id)}
                      sx={checkboxSx}
                    />
                  }
                  label={op.name}
                  sx={{
                    m: 0,
                    mb: index === operators.length - 1 ? 0 : 0.5,
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    "& .MuiFormControlLabel-label": {
                      color: "#fff",
                      fontSize: "0.875rem",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    },
                  }}
                />
              ))}
            </Box>
          </>
        )}
      </Box>
    </Paper>
  );
};

export default ManageAirframeFilter;
